import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
export class EventCapacitacionService {
    constructor() {
        this.invokeFirstComponentFunction = new EventEmitter();
    }
    onCapacitacionesComponentButtonClick() {
        this.invokeFirstComponentFunction.emit();
    }
}
EventCapacitacionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EventCapacitacionService_Factory() { return new EventCapacitacionService(); }, token: EventCapacitacionService, providedIn: "root" });
